export default "__VITE_ASSET__szUFtNh0__"